import React, { useState } from 'react';
import { Sun, Moon, LogOut, ShieldAlert, Settings, Info, ChevronDown, Home, Terminal, Brain, Target, ShoppingBag, User, MoreHorizontal, Bell } from 'lucide-react';

const menuItems = [
    { name: 'Lernen', icon: <Home size={28} /> },
    { name: 'Playground', icon: <Terminal size={28} /> },
    { name: 'Karteikarten', icon: <Brain size={28} /> },
    { name: 'Missionen', icon: <Target size={28} /> },
    { name: 'Shop', icon: <ShoppingBag size={28} /> },
    { name: 'Profil', icon: <User size={28} /> },
    { name: 'Mehr', icon: <MoreHorizontal size={28} /> },
];

function LeftSidebar({ activeTab, onTabChange, user, onLogout, darkMode, toggleDarkMode, notificationsEnabled, toggleNotifications }) {
  const [showMore, setShowMore] = useState(false);
  const [showInfos, setShowInfos] = useState(false);

  const handleItemClick = (name) => {
    if (navigator.vibrate) navigator.vibrate(10);
    if (name === 'Mehr') {
      setShowMore(!showMore);
    } else {
      onTabChange(name);
      setShowMore(false);
    }
  };

  return (
    <aside className="left-sidebar" style={{
      backgroundColor: darkMode ? 'rgba(30, 30, 30, 0.8)' : 'rgba(255, 255, 255, 0.7)',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      borderRight: darkMode ? '2px solid #333' : '2px solid #e5e5e5',
      zIndex: 100
    }}>
      <div className="logo-container">
        <h1 className="duocode-logo" onClick={() => onTabChange('Lernen')} style={{ cursor: 'pointer' }}>duocode</h1>
      </div>
      <ul>
        {menuItems.map(item => (
          <li 
            key={item.name} 
            className={`${activeTab === item.name ? 'active' : ''} menu-item-${item.name.toLowerCase()}`}
            onClick={() => handleItemClick(item.name)}
            style={{ height: '58px', display: 'flex', alignItems: 'center', position: 'relative' }}
          >
            <div className="menu-icon">
              {item.name === 'Profil' && user && user.photoURL ? (
                 <img src={user.photoURL} alt="Profil" style={{ width: '28px', height: '28px', borderRadius: '50%' }} referrerPolicy="no-referrer" />
              ) : (
                item.icon
              )}
            </div>
            <span>{item.name}</span>
            {item.name === 'Mehr' && showMore && (
              <div className="more-popover" style={{ 
                backgroundColor: darkMode ? '#1F1F1F' : '#FFFFFF', 
                border: darkMode ? '1px solid #333' : '1px solid #F0F0F0', 
                borderRadius: '20px', 
                padding: '8px', 
                minWidth: '220px', 
                boxShadow: '0 12px 40px rgba(0,0,0,0.15)', 
                zIndex: 200,
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                position: 'absolute',
                bottom: '100%',
                left: '0',
                marginBottom: '10px'
              }}>
                {user && user.email === 'schwingnorbert@gmail.com' && (
                  <button 
                    className="menu-item"
                    onClick={(e) => {
                      if (navigator.vibrate) navigator.vibrate(10);
                      e.stopPropagation();
                      onTabChange('Admin');
                      setShowMore(false);
                    }}
                  >
                    <ShieldAlert size={20} /> Admin Dashboard
                  </button>
                )}

                {/* Mobile Shop Link */}
                <div className="mobile-only-menu-item">
                  <button 
                    className="menu-item"
                    onClick={(e) => {
                      if (navigator.vibrate) navigator.vibrate(10);
                      e.stopPropagation();
                      onTabChange('Shop');
                      setShowMore(false);
                    }}
                  >
                    <ShoppingBag size={20} />
                    Shop
                  </button>
                </div>

                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: '10px', 
                    padding: '8px 12px 4px 12px', 
                    color: darkMode ? '#888' : '#999', 
                    fontSize: '0.85rem', 
                    fontWeight: '700' 
                }}>
                    <Settings size={16} />
                    <span>Einstellungen</span>
                    <div style={{ flex: 1, height: '2px', backgroundColor: darkMode ? '#333' : '#e5e5e5', marginLeft: '5px' }}></div>
                </div>
                <button 
                  className="menu-item"
                  onClick={(e) => {
                    if (navigator.vibrate) navigator.vibrate(10);
                    e.stopPropagation();
                    toggleNotifications();
                  }}
                style={{ justifyContent: 'space-between', padding: '6px 12px' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Bell size={20} />
                  <span>Nachrichten</span>
                  </div>
                  <div style={{ width: '40px', height: '22px', backgroundColor: notificationsEnabled ? '#1cb0f6' : '#e5e5e5', borderRadius: '20px', position: 'relative', transition: 'background-color 0.2s ease' }}>
                    <div style={{
                      width: '18px',
                      height: '18px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      position: 'absolute',
                      top: '2px',
                      left: notificationsEnabled ? '20px' : '2px',
                      transition: 'left 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                      boxShadow: '0 2px 2px rgba(0,0,0,0.1)'
                    }} />
                  </div>
                </button>
                <button 
                  className="menu-item"
                  onClick={(e) => {
                    if (navigator.vibrate) navigator.vibrate(10);
                    e.stopPropagation();
                    toggleDarkMode();
                  }}
                style={{ justifyContent: 'space-between', padding: '6px 12px', marginTop: '-4px' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {darkMode ? <Moon size={20} /> : <Sun size={20} />}
                    <span>Dark Mode</span>
                  </div>
                  <div style={{ width: '40px', height: '22px', backgroundColor: darkMode ? '#1cb0f6' : '#e5e5e5', borderRadius: '20px', position: 'relative', transition: 'background-color 0.2s ease' }}>
                    <div style={{
                      width: '18px',
                      height: '18px',
                      backgroundColor: 'white',
                      borderRadius: '50%',
                      position: 'absolute',
                      top: '2px',
                      left: darkMode ? '20px' : '2px',
                      transition: 'left 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                      boxShadow: '0 2px 2px rgba(0,0,0,0.1)'
                    }} />
                  </div>
                </button>
                
                {/* Mobile Infos Section */}
                <div className="mobile-only-menu-item">
                    <div style={{ height: '2px', backgroundColor: darkMode ? '#333' : '#e5e5e5', margin: '4px 12px' }}></div>
                    <button 
                        className="menu-item"
                        onClick={(e) => {
                            if (navigator.vibrate) navigator.vibrate(10);
                            e.stopPropagation();
                            setShowInfos(!showInfos);
                        }}
                        style={{ justifyContent: 'space-between' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <Info size={20} />
                            <span>Infos</span>
                        </div>
                        <ChevronDown size={16} style={{ transform: showInfos ? 'rotate(180deg)' : '0deg', transition: 'transform 0.2s' }} />
                    </button>
                    {showInfos && (
                        <div style={{ paddingLeft: '10px', display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '2px' }}>
                            {[
                                { label: 'ÜBER UNS', target: 'About' },
                                { label: 'BLOG', target: null },
                                { label: 'KONTAKT', target: null },
                                { label: 'DATENSCHUTZ', target: 'Datenschutz' },
                                { label: 'IMPRESSUM', target: 'Impressum' }
                            ].map(link => (
                                <button key={link.label} className="menu-item" onClick={(e) => { e.stopPropagation(); if(link.target) onTabChange(link.target); setShowMore(false); }} style={{ fontSize: '0.85rem', padding: '8px 12px', color: darkMode ? '#aaa' : '#777' }}>
                                    {link.label}
                                </button>
                            ))}
                        </div>
                    )}
                </div>

                <div style={{ height: '2px', backgroundColor: darkMode ? '#333' : '#e5e5e5', margin: '4px 12px' }}></div>
                <button className="menu-item logout" onClick={(e) => {
                  if (navigator.vibrate) navigator.vibrate(10);
                  e.stopPropagation();
                  onLogout();
                }}>
                  <LogOut size={20} />
                  Abmelden
                </button>
                <style>{`
                  .more-popover {
                    animation: popIn 0.2s cubic-bezier(0.16, 1, 0.3, 1);
                    transform-origin: bottom left;
                  }
                  @keyframes popIn {
                    from { opacity: 0; transform: scale(0.9) translateY(10px); }
                    to { opacity: 1; transform: scale(1) translateY(0); }
                  }
                  .menu-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px 12px;
                    border-radius: 12px;
                    cursor: pointer;
                    background: none;
                    border: none;
                    color: ${darkMode ? '#E5E5E5' : '#4B4B4B'};
                    font-size: 0.95rem;
                    font-weight: 700;
                    transition: all 0.15s ease;
                    width: 100%;
                    text-align: left;
                  }
                  .menu-item:hover {
                    background-color: ${darkMode ? 'rgba(255,255,255,0.08)' : '#F5F5F5'};
                    transform: translateX(2px);
                  }
                  .menu-item.logout:hover {
                    background-color: rgba(255, 75, 75, 0.1);
                    color: #ff4b4b;
                  }
                `}</style>
              </div>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default LeftSidebar;